var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#EDF5FF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1971_30672)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1971_30672",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 6H6V24H24V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1971_30672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9994 18.245C13.207 18.245 11.752 16.79 11.752 14.9975C11.752 13.205 13.207 11.75 14.9994 11.75C16.7919 11.75 18.2469 13.205 18.2469 14.9975C18.2469 16.79 16.7919 18.245 14.9994 18.245ZM14.9994 12.875C13.8294 12.875 12.877 13.8275 12.877 14.9975C12.877 16.1675 13.8294 17.12 14.9994 17.12C16.1694 17.12 17.1219 16.1675 17.1219 14.9975C17.1219 13.8275 16.1694 12.875 14.9994 12.875Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0006 21.7644C12.1805 21.7644 9.51805 20.1144 7.68805 17.2494C6.89305 16.0119 6.89305 13.9944 7.68805 12.7494C9.52555 9.88438 12.188 8.23438 15.0006 8.23438C17.8131 8.23438 20.4756 9.88438 22.3056 12.7494C23.1006 13.9869 23.1006 16.0044 22.3056 17.2494C20.4756 20.1144 17.8131 21.7644 15.0006 21.7644ZM15.0006 9.35938C12.578 9.35938 10.2605 10.8144 8.64055 13.3569C8.07805 14.2344 8.07805 15.7644 8.64055 16.6419C10.2605 19.1844 12.578 20.6394 15.0006 20.6394C17.4231 20.6394 19.7406 19.1844 21.3606 16.6419C21.9231 15.7644 21.9231 14.2344 21.3606 13.3569C19.7406 10.8144 17.4231 9.35938 15.0006 9.35938Z",
    fill: "#002857"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1971_30672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBlueIcon);
export default __webpack_public_path__ + "static/media/eye_blue_icon.75adb7b6587df417274f180af1b12f7d.svg";
export { ForwardRef as ReactComponent };